import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import PropagateLoader from "react-spinners/PropagateLoader";
import { archiveListRes, archiveListTodo } from '../../LMS_Redux/LMS_Slices/Course/ArchiveCourseList';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { Tooltip } from 'react-tooltip';
import { LuPlayCircle } from "react-icons/lu";

export default function ArchiveCourseList() {

    const { state } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const archive = useSelector(state => state.archiveCourseList && state.archiveCourseList.data && state.archiveCourseList.data.data)
    const [loading, setLoading] = useState(false)
    // console.log(archive)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'IMAGE',
            field: 'thumbnail_image',
            cellRenderer: (params) => <img src={process.env.REACT_APP_IMAGE_URL + `${params.value}`} alt="img" className='img-fluid' width="50" height="50" />,
            suppressMenu: true,
            filter: false,
            sortable: false,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TITLE',
            field: 'course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'course_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'DEPARTMENT',
        //     field: 'department_data',
        //     valueFormatter: function (params) {
        //         return params.data.department_data.map(val => `${val.label}`).join(',')
        //     },
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'REVISION',
            field: 'revise',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <LuPlayCircle size={20} className='eye'
                        onClick={() => course_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Learning Module Details!"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            autoHeight: true,
        }
    ]);

    const course_details = (params) => {
        navigate('/course_details', { state: params.data })
    }

    const archive_res = () => {
        if (archiveListRes && archiveListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(archiveListTodo(state && state.course_code_original)).then(() => archive_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <Link to={'/course_list'}><span className='icon2'>Learning Module List / </span></Link>
                    <span className='icon2'>Archive Learning Module</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <>
                        {archive && archive.length ?
                            <DataTables
                                rowData={archive}
                                columnDefs={columnDefs}
                            />
                            :
                            <div className='wrapper-admin'>
                                <div className='text-center'>
                                    <h5>Archive Learning Module List Not Found</h5>
                                </div>
                            </div>
                        }
                    </>
                }

            </div>
        </>
    )
}
